import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasPermission } from "../helpers";
import Config from "../Config";

export default function ProtectedRoute({ permission, children }) {
  const user = useSelector((state) => state.UserReducer.user);
  if (user && (
    user?.userType === Config.USER_TYPE.CLIENT ||
    user?.role === Config.STAFF_ROLES.PARTNER
  )) {
    return children;
  }

  // If user does NOT have permission -> redirect
  if (!permission || !user || !user.permissions) {
    return <Navigate to="/no-access" replace />;
  }

  if (!hasPermission(permission, user)) {
    return <Navigate to="/no-access" replace />;
  }
  return children;
}
